import { Component, input } from '@angular/core';
import { DatatableFilterAbstractDirective } from '../datatable-filter-abstract.directive';
import { NEVER_USED_VALUE } from '../../datatable-filter.service';
import { ZiroIcons } from '../../../../models/ziro-icons.enum';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { PipesModule } from '../../../../pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { DatatableSliderComponent } from './datatable-slider/datatable-slider.component';

@Component({
  selector: 'ziro-datatable-slider-filter',
  templateUrl: './datatable-slider-filter.component.html',
  styleUrls: ['./datatable-slider-filter.component.scss', '../datatable-filter-abstract.directive.scss'],
  imports: [
    NgbDropdown,
    TranslateModule,
    NgClass,
    PipesModule,
    FormsModule,
    DatatableSliderComponent,
    NgbDropdownToggle,
    NgbDropdownMenu,
  ],
  providers: [{ provide: DatatableFilterAbstractDirective, useExisting: DatatableSliderFilterComponent }],
})
export class DatatableSliderFilterComponent extends DatatableFilterAbstractDirective<number> {
  readonly ceilValue = input<number>();
  readonly floorValue = input(0);
  readonly floorValueLabel = input<string>();
  readonly toggleLabel = input<string>();
  readonly sliderLabel = input<string>();
  sliderValue = 0;
  neverUsed: boolean;
  isDropDownOpen: boolean;
  disableDropDownOptions = true;
  previousValue = 0;

  clear: () => void = () => {
    this.disableDropDownOptions = true;
    this.sliderValue = 0;
    this.neverUsed = false;
    this.value = null;
  };

  clearInput(): void {
    this.clear();
    this.filterUpdateSource.next();
  }

  updateSlider(): void {
    if (this.neverUsed) {
      this.previousValue = this.value;
      this.value = NEVER_USED_VALUE;
    } else {
      this.value = this.previousValue >= 0 ? this.previousValue : null;
      this.sliderValue = this.value ? this.value : 0;
    }
  }

  onChange(newValue: number): void {
    this.disableDropDownOptions = false;
    this.value = this.neverUsed ? NEVER_USED_VALUE : newValue;
  }

  getFilterLabel(): string {
    if (this.neverUsed) {
      return 'tkey;reports.datatable.filter.slider.never';
    } else if (this.value === 0) {
      return 'tkey;time.today';
    } else if (this.value === 1) {
      return 'tkey;reports.device_utilization.last_used.singular';
    } else if (!!this.value && (!this.neverUsed || this.isDropDownOpen)) {
      return 'tkey;reports.datatable.filter.slider.number.of.days';
    }
    return 'tkey;reports.datatable.filter.select.all';
  }

  openChange($event: boolean): void {
    this.isDropDownOpen = $event;
    if (!this.isDropDownOpen) {
      this.filterUpdateSource.next();
    }
  }

  protected readonly ziroIcons = ZiroIcons;
}
